<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="employees.employeeID > 0 ? '编辑' : '新建'"
      class="employee-edit"
      width="900px"
      top="10vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        :model="employees"
        :rules="ruleValidate"
        class="form"
        label-width="80px">
      <el-row>
        <el-col :span="8">
          <el-form-item label="编号">
            <el-input v-model="employees.employeeNO" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="姓名" prop="employeeName">
            <el-input v-model="employees.employeeName" placeholder="请输入姓名"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="性别">
            <el-radio-group v-model="employees.gender">
              <el-radio :label="0">男</el-radio>
              <el-radio :label="1">女</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="部门" prop="departmentName">
            <el-input v-model="employees.departmentName" placeholder="请选择部门" readonly>
              <el-button slot="append" @click="$refs.selectDepartment.open()">选择</el-button>
            </el-input>
            <!-- 部门选择器 -->
            <department-select ref="selectDepartment" @select="selectDepartment"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="职位" prop="postID">
            <el-select v-model="employees.postID" clearable placeholder="请选择职位" filterable>
              <el-option v-for="item in positionList" :key="item.postID" :label="item.postName" :value="item.postID"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="海尔工号">
            <el-input v-model="employees.oaNumber" placeholder="请输入外部编号"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="电话">
            <el-input v-model="employees.telephone" placeholder="请输入电话"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="手机" prop="mobile">
            <el-input v-model="employees.mobile" placeholder="请输入手机"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="住址">
            <el-input v-model="employees.address" placeholder="请输入住址"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="电子邮箱">
            <el-input v-model="employees.email" placeholder="请输入电子邮箱"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="邮编">
            <el-input v-model="employees.postCode" placeholder="请输入邮编"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="生日">
            <el-date-picker
                v-model="employees.birthday"
                align="right"
                style="width: 100%"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd HH:mm:ss"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="备注">
        <el-input v-model="employees.note" type="textarea" placeholder="请输入"/>
      </el-form-item>
      <el-button type="primary" style="margin-bottom: 10px" @click="$refs.selectSkill.open()"> 添加技能</el-button>
      <el-table border :data="employees.employeeSkills">
        <el-table-column type="index" align="center" label="#" width="55"/>
        <el-table-column prop="skillNo" align="center" width="120" label="编号"/>
        <el-table-column prop="skillName" align="left" label="名称"/>
        <el-table-column prop="startDate" align="center" label="授权开始日期">
          <template slot-scope="scope">
            <el-date-picker
                v-model="scope.row.startDate"
                style="width: 100%"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"/>
          </template>
        </el-table-column>
        <el-table-column prop="endDate" align="center" label="授权结束日期">
          <template slot-scope="scope">
            <el-date-picker
                v-model="scope.row.endDate"
                style="width: 100%"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"/>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="80px">
          <template slot-scope="scope">
            <el-button type="danger" @click="oneDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <skill-select ref="selectSkill" @select="addSkill"/>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="submit">确定</el-button>
    </span>
  </el-dialog>
</template>
 
<script>
  import constants from "../../../util/constants";
  import DepartmentSelect from "@/views/information/Department/DepartmentSelect";
  import SkillSelect from "../Skill/SkillSelect";
 
  export default {
    name: "EmployeeEdit",
    components: {SkillSelect, DepartmentSelect},
    data() {
      return {
        constants,
        positionList: [],
        dialogVisible: false,
        submitLoading: false,
        employees: {
          employeeID: 0,
          employeeNO: "",
          employeeName: "",
          gender: 0,
          departmentName: "",
          outerNo: "",
          postID: "",
          birthday: "",
          telephone: "",
          mobile: "",
          address: "",
          email: "",
          postCode: "",
          note: "",
          employeeSkills: [],
          oaNumber:"",
        },
        ruleValidate: {
          employeeName: {required: true, message: "请输入姓名", trigger: "blur"},
          departmentName: {required: true, message: "请选择部门", trigger: "change"},
          postID: {required: true, message: "请选择职位", trigger: "change"},
        },
      };
    },
    methods: {
      open(row) {
        this.dialogVisible = true;
        this.getPositionList();
        if (row) {
          this.employees.employeeID = row.employeeID;
          this.getData();
        } else {
          this.getNode();
        }
      },
 
      // 获取职位列表
      getPositionList() {
        this.$http.get("basic", "posts/list").then((resp) => {
          if (resp.success) {
            this.positionList = resp.data;
          }
        });
      },
 
      // 选择部门
      selectDepartment(row) {
        this.employees.departmentID = row.departmentID;
        this.employees.departmentName = row.departmentName;
      },
 
      // 根据员工id查询信息
      getData() {
        this.$http.get("basic", `employees/${this.employees.employeeID}`).then((resp) => {
          if (resp.success) {
            this.employees = resp.data;
          }
        });
      },
 
      // 获取员工编号
      getNode() {
        this.$http.get("basic", "employees/selectNo").then((resp) => {
          if (resp.success) {
            this.employees.employeeNO = resp.data;
          }
        });
      },
 
      // 提交
      submit() {
        if (this.employees.employeeID > 0) {
          this.handleSubmitUpdData();
        } else {
          this.handleSubmitSave();
        }
      },
 
      addSkill(row) {
        for (let item of this.employees.employeeSkills) {
          if (item.skillId === row.pkid) {
            this.$confirm("技能：" + row.skillName + "已存在，请勿重复添加", "错误", {
              type: "error",
              showCancelButton: false,
            });
            return;
          }
        }
        this.employees.employeeSkills.push({
          pkid: 0,
          masterId: 0,
          skillId: row.pkid,
          skillNo: row.skillNo,
          skillName: row.skillName,
          startDate: "",
          endDate: "",
        });
      },
 
      //删除
      oneDelete(index) {
        this.employees.employeeSkills.splice(index, 1);
      },
 
      // 编辑
      handleSubmitUpdData() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .put("basic", "employees", this.employees)
              .then((resp) => {
                if (resp.success) {
                  this.submitLoading = false;
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("编辑成功");
                }
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
 
      // 新建
      handleSubmitSave() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .post("basic", "employees", this.employees)
              .then((resp) => {
                if (resp.success) {
                  this.submitLoading = false;
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("添加成功");
                }
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>